import data from '@/sui/data/check'
import sheets from '@/sui/data/sheets/check'

export default function () {
  data()
  sheets()
}
